import { AxiosError } from 'axios';
import createApiClient from '../apiClient';
import DispatcherNotes from '../../../types/DispatcherNotes.types';
import {
    getErrorMessage,
    createErrorTelemetryProperties,
    logError,
    logInformation,
    trackError
} from '../../../utils/AppInsightUtils';

export const getDispatcherNotes = async (accessToken: string): Promise<string | null> => {
    const url = '/marginalweatherapi/DispatcherNotes/Get';
    try {
        logInformation('Fetching dispatcher notes', 'MarginalWeatherAPI', 'getDispatcherNotes');
        const response = await createApiClient(accessToken).get<string>(url);
        logInformation('Successfully fetched dispatcher notes', 'MarginalWeatherAPI', 'getDispatcherNotes');
        return response?.data;
    }
    catch (error) {
        trackError(error as Error);
        logError(
            getErrorMessage(new Error(`Failed to fetch dispatcher notes`)),
            'DispatcherNotesModule',
            'getDispatcherNotes',
            createErrorTelemetryProperties(error as Error | AxiosError)
        );
        return null;
    }
};

export const updateDispatcherNotes = async (notes: DispatcherNotes, accessToken: string): Promise<string | null> => {
    const url = '/marginalweatherapi/DispatcherNotes/Update';
    try {
        logInformation('Updating dispatcher notes', 'MarginalWeatherAPI', 'updateDispatcherNotes');
        const response = await createApiClient(accessToken).put<string>(url, notes);
        logInformation('Successfully updated dispatcher notes', 'MarginalWeatherAPI', 'updateDispatcherNotes');
        return response?.data;
    }
    catch (error) {
        trackError(error as Error);
        logError(
            getErrorMessage(new Error(`Failed to update dispatcher notes`)),
            'DispatcherNotesModule',
            'updateDispatcherNotes',
            createErrorTelemetryProperties(error as Error | AxiosError)
        );
        return null;
    }
};

